import type { CompanyFilters } from "../../types";
import { defaultPromotionDateSlice, type PromotionDateSlice } from "./slice";

export function toCompanyFilters(
  slice: PromotionDateSlice
): Partial<CompanyFilters> {
  return slice.date
    ? { companyPromotionDate: { operator: slice.operator, date: slice.date } }
    : {};
}

export function fromCompanyFilters(
  filters: CompanyFilters
): PromotionDateSlice {
  const filter = filters.companyPromotionDate;
  if (!filter?.date) return defaultPromotionDateSlice;
  return { operator: filter.operator, date: filter.date };
}
